import {dateToUsString} from "../../../date-converter";

// whole calendar months between two dates, in years, floored to the nearest half year
const yearsBetween = (start, end) => {
    if (isNaN(start) || isNaN(end)) return 0;
    let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    if (end.getDate() < start.getDate()) months--;
    return Math.floor(months / 6) / 2;
};

export default {
    name: 'LEASE SUMMARY',
    rows: {
        'original-lease-term': {
            name: 'Original Lease Term',
            unit: 'Years',
            type: 'number',
            editable: false,
            tooltip: '= lease_expiration - lease_commencement',
            value: '',
            getComputedValue: function (tables) {
                const leaseCommencementDate = new Date(tables['lease-summary'].rows['lease-commencement'].value);
                const leaseExpirationDate = new Date(tables['lease-summary'].rows['lease-expiration'].value);
                // expiration is the last day of the lease (e.g. 12/04/1993 - 12/03/2028), so count through the next day
                leaseExpirationDate.setDate(leaseExpirationDate.getDate() + 1);
                const value = yearsBetween(leaseCommencementDate, leaseExpirationDate);
                const displayValue = value && !isNaN(value) ? `${value} ${value <= 1 ? 'Year' : 'Years'}` : '-';
                return {internalValue: value, displayValue};
            },
        },
        'lease-commencement': {
            name: 'Lease Commencement',
            type: 'date',
            editable: true,
            value: '',
            getComputedValue: function (tables, columnIndex, closeOfEscrow) {
                if(closeOfEscrow)
                    return {internalValue: closeOfEscrow, displayValue: closeOfEscrow};
                
                const value = new Date(tables['general-information'].rows['analysis-date'].value);
                value.setMonth(value.getMonth()+6)
                return {internalValue: dateToUsString(value), displayValue: 'At Close of Escrow' };
            },
        },
        'lease-expiration': {
            name: 'Lease Expiration',
            type: 'date',
            editable: true,
            value: '',
            getComputedValue: function (tables, columnIndex, closeOfEscrow) {
                const originalLeaseTerm = tables['lease-summary'].rows['original-lease-term'].value || '';
                const leaseCommencement = tables['lease-summary'].rows['lease-commencement'].getComputedValue(tables,'',closeOfEscrow).internalValue || '';

                if (!originalLeaseTerm)
                    return {internalValue: null, displayValue: '_ Years from COE'};
                if (!closeOfEscrow && !leaseCommencement)
                    return {internalValue: null, displayValue: `${originalLeaseTerm} Years from COE`};

                let leaseExpiration;
                const escrow = new Date(leaseCommencement);

                let year = escrow.getFullYear();
                let month = escrow.getMonth();
                var lastDay = new Date(year, escrow.getMonth(), 0).getDate();
                if(escrow.getDate()>14){      
                    month = month+1;
                    if(month==13){
                        month=1;
                        year = year+1;
                    }
                   
                    lastDay = new Date(year, escrow.getMonth() + 2, 0).getDate();
                }else{
                    month = month-1;
                    if(month<1){
                        month=11;
                        year = year-1;
                    }
                }
                escrow.setFullYear(year);
                escrow.setMonth(month);
                escrow.setDate(lastDay)
                
                // if the day is not first of the month, set it at the end of the month
                if (escrow.getDate() !== 1)
                    leaseExpiration = dateToUsString(new Date(escrow.getFullYear() + parseInt(originalLeaseTerm), escrow.getMonth()+1, 0));
                else
                    leaseExpiration = dateToUsString(new Date(escrow.getFullYear() + parseInt(originalLeaseTerm), escrow.getMonth(), 1));
                return {internalValue: leaseExpiration, displayValue : closeOfEscrow ? leaseExpiration : `${originalLeaseTerm} Years from COE`};
            },
        },
        'remaining-term': {
            name: 'Remaining Term',
            unit: 'Years',
            type: 'number',
            editable: false,
            getComputedValue: function (tables, columnIndex, closeOfEscrow) {
                // is Sale Lease Back and property is not Closed
                if (!tables['lease-summary'].rows['lease-expiration'].editable && !closeOfEscrow) {
                    const value = tables['lease-summary'].rows['original-lease-term'].value;
                    const displayValue = value && !isNaN(value) ? `${value} ${value <= 1 ? 'Year' : 'Years'}` : '-';
                    return {internalValue: value, displayValue};
                }

                // is Sale Lease back and property is Closed
                const leaseExpiration = tables['lease-summary'].rows['lease-expiration'].editable ?
                    new Date(tables['lease-summary'].rows['lease-expiration'].value)
                    :
                    new Date(tables['lease-summary'].rows['lease-expiration'].getComputedValue(tables, '', closeOfEscrow).internalValue);
                const analysisDate = new Date(tables['general-information'].rows['analysis-date'].value);
                const value = yearsBetween(analysisDate, leaseExpiration);
                const displayValue = value && !isNaN(value) ? `${value} ${value <= 1 ? 'Year' : 'Years'}` : '-';
                return {internalValue: value, displayValue};
            }
        },
        'lease-type': {
            name: 'Lease Type',
            unit: '',
            type: 'dropdown',
            editable: true,
            value: 'Ground',
            dropdownValues: '',
        },
        'roof-and-structure': {
            name: 'Roof & Structure',
            unit: '',
            editable: false,
            tooltip: '= IF(lease_type = Ground OR lease_type = NNN) Tenant ELSE Landlord',
            getComputedValue: function (tables) {
                const leaseType = tables['lease-summary'].rows['lease-type'].value;
                let value = '';

                if (!leaseType || leaseType === '-') {
                    value = '-';
                } else if (leaseType === 'Ground' || leaseType === 'NNN') {
                    value = 'Tenant';
                } else {
                    value = 'Landlord';
                }

                return {internalValue: value, displayValue: value};
            }
        },
        'increases': {
            name: 'Increases',
            unit: '',
            type: 'text',
            editable: true,
            value: '',
        },
        'guarantor': {
            name: 'Guarantor',
            unit: '',
            type: 'dropdown',
            editable: true,
            value: '',
            dropdownValues: '',
        },
        'options': {
            name: 'Options',
            unit: '',
            type: 'text',
            editable: true,
            value: '',
        },
        'options-to-purchase': {
            name: 'Options to Purchase',
            unit: '',
            type: 'dropdown',
            editable: true,
            value: '',
            dropdownValues: '',
        },
    }
};